import React from "react";

export default function ContactPage() {
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 sm:p-10">
                <h1 className="text-3xl font-bold text-gray-900 mb-6">Contact Us</h1>

                <div className="space-y-6 text-gray-700 leading-relaxed">
                    <p>
                        Have questions or feedback about OmniWorth? We'd love to hear from you.
                    </p>

                    <div className="card p-6 my-8">
                        <h2 className="text-xl font-semibold text-gray-900 mb-4">Get in Touch</h2>
                        <div className="space-y-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center shrink-0">
                                    <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Email</p>
                                    <a
                                        href="mailto:support@omniworth.net"
                                        className="text-accent-600 hover:text-accent-700 transition-colors"
                                    >
                                        support@omniworth.net
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p>
                        We're always looking for ways to improve! Feel free to suggest new
                        features, report bugs, or just say hello.
                    </p>

                    <div className="card p-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Response Time</h3>
                        <p className="text-gray-700">
                            We typically respond to inquiries within 24-48 hours during business days.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
